export const plans = [
  {
    name: "Light",
    price: 0,
    description: "A free, limited-access way to explore what SheetShark can do.",
    features: [
      { title: "10 Formula Generations", sub: "Per month with access to AI assistance" },
      { title: "Basic Chat Support", sub: "Ask questions or get help with formulas" },
    ],
    highlight: false,
    badge: "Light",
  },
  {
    name: "Pro",
    price: 9.99,
    description: "Full access to everything SheetShark offers — designed for those ready to dive deeper.",
    features: [
      { title: "Unlimited Formula Generations", sub: "No monthly cap on AI assistance" },
      { title: "Unlimited Chat Messages", sub: "Full access to formula-related chat support" },
      { title: "Graphing & Visual Insights", sub: "Generate charts and visual summaries" },
      { title: "Faster Response Times", sub: "Get priority access and reduced wait times" },
    ],
    highlight: true,
    badge: "Pro",
  },
];
